import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useCurrentSpaceId, useSpaceCredits } from '@/entities/teamspace';

import { PATHS } from '@/shared/constants/routes/paths';
import { clearLandingMediaKind } from '@/shared/lib/landingMediaKind';
import { showErrorAlert } from '@/shared/lib/showErrorAlert';

import { useLandingProjectStore } from './useLandingProjectStore';

export const useLandingFlow = () => {
  const navigate = useNavigate();
  const urlSpaceId = useCurrentSpaceId();

  const status = useLandingProjectStore((state) => state.status);
  const progress = useLandingProjectStore((state) => state.progress);
  const projectId = useLandingProjectStore((state) => state.projectId);
  const storeSpaceId = useLandingProjectStore((state) => state.spaceId);
  const error = useLandingProjectStore((state) => state.error);
  const reset = useLandingProjectStore((state) => state.reset);

  const { refetch: refetchCredits } = useSpaceCredits();

  const isLandingFlow = status === 'creating' || status === 'ready';

  useEffect(() => {
    if (status === 'ready' && projectId) {
      const spaceId = storeSpaceId || urlSpaceId;

      navigate(`/${PATHS.spaces}/${spaceId}/${PATHS.project}/${projectId}`);
      reset();
      void refetchCredits();
    } else if (status === 'failed') {
      showErrorAlert(error);
      reset();
      clearLandingMediaKind();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, projectId]);

  return { isLandingFlow, landingProgress: progress };
};
